<template>
  <div class="col-12">
    <!-- <div class="col-12" style="margin-top: 10px">
      <h4 style="color: blue">Farmer Dashboard</h4>
      <hr />
    </div> -->
    <div class="col-12">
      <div class="col-12" style="margin-top: 10px">

        
        <h4 style="margin-top:5px;"> Buy Animals
       <b-button class="float-right" @click="handleBack" variant="danger">
          <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
      </b-button>
    </h4>

        <!-- <h4 class="animalKatta">
          Buy Animals

          <b-btn
            class="btn-danger"
            style="text-align: right; margin-left: 2px"
            @click="back()"
          >
            <b-icon-arrow-left-circle-fill></b-icon-arrow-left-circle-fill> Back
          </b-btn>
        </h4> -->

        <hr />
      </div>
    </div>
    <div class="row">
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="cowdetails">
            <img
              src="../assets/114.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th class="animalKattaDesc">Name</th>
                    <td class="animalKattaDesc">Cow</td>
                  </tr>
                  <tr>
                    <th class="animalKattaDesc">Amount</th>
                    <td class="animalKattaDesc">1000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div
        class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6"
        style="height: 200px"
      >
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="Oxdetails">
            <img
              src="../assets/ox.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th class="animalKattaDesc">Name</th>
                    <td class="animalKattaDesc">ox</td>
                  </tr>
                  <tr>
                    <th class="animalKattaDesc">Amount</th>
                    <td class="animalKattaDesc">12000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="Goatdetails">
            <img
              src="../assets/111.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th class="animalKattaDesc">Name</th>
                    <td class="animalKattaDesc">Goat</td>
                  </tr>
                  <tr>
                    <th class="animalKattaDesc">Amount</th>
                    <td class="animalKattaDesc">5000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
      <div class="col-xl-3 col-lg-3 col-md-4 col-sm-6 col-6">
        <b-card style="max-width: 20rem" class="mb-2">
          <b-card-text @click="Buffelodetails">
            <img
              src="../assets/123.jpg"
              height="150px"
              width="140px"
              style="object-fit: cover; padding-right: 15px"
            />
            <div class="row">
              <div
                class="col-12"
                style="
                  font-family: Arial;
                  font-size: 18px;
                  padding: 20px;
                  padding-bottom: 0px;
                "
              >
                <table>
                  <tr>
                    <th class="animalKattaDesc">Name</th>
                    <td class="animalKattaDesc">Buffalo</td>
                  </tr>
                  <tr>
                    <th class="animalKattaDesc">Amount</th>
                    <td class="animalKattaDesc">1000</td>
                  </tr>
                </table>
              </div>
            </div>
          </b-card-text>
        </b-card>
      </div>
    </div>
    <div class="col-12">
      <b-btn class="btn-success float-center animalKattaDesc" @click="view()">
        More </b-btn
      >&nbsp;
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabIndex: 0,
    };
  },
  methods: {

    handleBack(){
          this.$router.go("-1");
      },

    view() {
      this.$router.push("/buyer");
    },
    add() {
      this.$router.push("/add_animal");
    },
    handleDetails() {
      this.$router.push("/cowdetails");
    },
    handleDoctor() {
      this.$router.push("/home/nearby_doctor");
    },
    handleCertificate() {
      this.$router.push("/transportcertificate");
    },
    handleProfile() {
      this.$router.push("/farmer_profile");
    },
    oxDetails() {
      this.$router.push("/oxdetails");
    },
    goatDetails() {
      this.$router.push("/goatdetails");
    },
    buffeloDetails() {
      this.$router.push("/buffelodetails");
    },
    cowdetails() {
      this.$router.push("/Cowviewdetails");
    },
    Oxdetails() {
      this.$router.push("/Oxviewdetails");
    },
    Goatdetails() {
      this.$router.push("/Goatviewdetails");
    },
    Buffelodetails() {
      this.$router.push("/Buffeloviewdetails");
    },
  },
};
</script>
